var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "z-logo" },
    [
      _vm.isIndex
        ? [
            _c("img", {
              staticClass: "z-logo__img",
              attrs: { src: _vm.buildSrc },
            }),
          ]
        : [
            _c(
              "a",
              {
                staticClass: "z-logo__link",
                attrs: { href: _vm.siteDir, title: _vm.title },
              },
              [
                _c("img", {
                  staticClass: "z-logo__img",
                  attrs: { src: _vm.buildSrc },
                }),
              ]
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }